import axios from '@/api/axios'

export default {

    downloadAppVersion(params) {
        return axios.get('/api/home/appversion/download_app', params)
    },
    getSoftList(params) {
        return axios.get('/api/home/software/user/soft_list', params)
    },
}
